/**
 * @generated SignedSource<<9bef9af5113ec8b11cc970c9af1365d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type agendaGeneratorDismissAgendaGeneratorMutation$variables = {
  noteId: string;
};
export type agendaGeneratorDismissAgendaGeneratorMutation$data = {
  readonly dismissAgendaGenerator: {
    readonly note: {
      readonly viewerAgendaGeneratorBannerDismissed: boolean;
    };
  } | null;
};
export type agendaGeneratorDismissAgendaGeneratorMutation = {
  response: agendaGeneratorDismissAgendaGeneratorMutation$data;
  variables: agendaGeneratorDismissAgendaGeneratorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerAgendaGeneratorBannerDismissed",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agendaGeneratorDismissAgendaGeneratorMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissAgendaGenerator",
        "kind": "LinkedField",
        "name": "dismissAgendaGenerator",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agendaGeneratorDismissAgendaGeneratorMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissAgendaGenerator",
        "kind": "LinkedField",
        "name": "dismissAgendaGenerator",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e026ad779432193a30a54f26a2ec3ab5",
    "id": null,
    "metadata": {},
    "name": "agendaGeneratorDismissAgendaGeneratorMutation",
    "operationKind": "mutation",
    "text": "mutation agendaGeneratorDismissAgendaGeneratorMutation(\n  $noteId: ID!\n) {\n  dismissAgendaGenerator(noteId: $noteId) {\n    note {\n      viewerAgendaGeneratorBannerDismissed\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ed301c220a94fd79b74f4fea0dacfa5";

export default node;
